
export default  {
    primary: '#f4511e',
    black: '#000',
    headerTintColor:'#000',
    headerTextColor:'#000',
    headerTextFontWeight:'600',
    statuBarColor:'#000',
    statuBarColor:'red',
    black:'#222222',
    primary_dark:'#2c387e',
    primary_medium:'#3f51b5',
    primary_light:'#6573c3',

    danger_dark:'#ab003c',
    danger_medium:'#ab003c',
    danger_light:'#f73378',

    success_dark: '#4CAF50',
    success_medium:'#2E7D32',
    success_light:'#66BB6A',

    warning_dark:'#FFEB3B',
    warning_medium :'#FFF59D',
    warning_light:'#FFF9C4',

    secondary:'#cccccc',

    info_dark:'#3D5AFE',
    info_medium:'#536DFE',
    info_light:'#3F51B5',

    imageBgColor:'#eaeaea',

    toastBgColor:'#707070',
    toastPaddingHorizontal:25,
    toastPaddingVertical:10,
    toastTextColor:'#fff',
    toastPositionValue:150,
    toastPosition:'bottom',
    statusBarHeight: 60,
    quizFont: 'Spectral-SemiBold',
    priceColor: '#662adf'
    
}
